var _rect, _path, _path2, _path3, _path4, _ellipse, _path5, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVacateHouse1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 134,
    viewBox: "0 0 202 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 82.6562,
    width: 152,
    height: 39,
    fill: "#2B374E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 102.156L146 133.656L146 70.6562L184 102.156Z",
    fill: "#2B374E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73.3362L97.6167 49.6875L81.6216 67.8947V107.117H110V73.3362Z",
    fill: "#BFD9F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 72.3906H83.5136V107.117H40V72.3906Z",
    fill: "#E8F2FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4363 49.6875H54.8289L40 72.3902H83.5136L97.4363 49.6875Z",
    fill: "#8CAFD9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.5608,
    cy: 23.7681,
    rx: 23.4244,
    ry: 23.4244,
    fill: "#2B374E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8035 55.7422L63.156 39.0323L82.4509 39.0323L72.8035 55.7422Z",
    fill: "#2B374E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.312,
    y: 15.1328,
    width: 23.2422,
    height: 2.34244,
    transform: "rotate(45 66.312 15.1328)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.7463,
    y: 16.2656,
    width: 23.2422,
    height: 2.34244,
    transform: "rotate(135 82.7463 16.2656)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVacateHouse1);
export default __webpack_public_path__ + "static/media/IcVacateHouse1.927596522f74835ccb2367444c52e247.svg";
export { ForwardRef as ReactComponent };